import React, { useEffect, useState } from "react";
import BellIcon from "../../assets/icons/BellIcon";
import BookmarkIcon from "../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import SearchIcon from "../../assets/icons/SearchIcon";
import Checkbox from "../../common/Checkbox";
import CloseIcon from "@mui/icons-material/Close";

import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Modal,
  Typography,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { updateCaseList, viewCase } from "../../services/cases";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../utils/Utilities";
import { borderRadius, Box, Container } from "@mui/system";
import { SecondaryButton } from "../../common/Buttons";
import RestoreCaseBox from "./RestoreCaseBox";
import { useSelector } from "react-redux";
import { Circles } from "react-loader-spinner";

import "./index.scss";
import CasesDropdownMenu from "./CasesDropdown";
import { useTranslation } from "react-i18next";
import FormattedDate from "./../../utils/TabelDateFormat";
const Cases = ({
  data,
  handleRefresh,
  search,
  handleSearch,
  searchFilterState,
  handleFilterStateActive,
  entireCasesText,
  handleEntireCasesText,
  handleSetConsultantFilter,
  selectedConsultant,
  consultantsList,
  selectedConsultantName,
}) => {
  let uID = getUserIdFromLocalStorage();
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const loading = useSelector((state) => state.casesState.cases.loading);
  const [list, setList] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [timerCheck, setTimerCheck] = useState(false);
  const [beingRestored, setBeingRestored] = useState(false);
  const [timer, setTimer] = useState(5000);
  const [openConsultantFilter, setOpenConsultantFilter] = useState(false);
  useEffect(() => {
    setList(
      data
        ?.filter((item) => !item.isDeleted)
        ?.map((item) => ({ ...item, isChecked: false } || []))
    );
  }, [data]);

  useEffect(() => {
    if (timerCheck) {
      if (!beingRestored) {
        setTimeout(() => {
          setTimerCheck(false);
        }, timer);
      }
    }
  }, [timerCheck]);
  const handleChangeCheck = (e) => {
    e.stopPropagation();
    setList(
      list.map((item) => {
        if (item.caseId == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };
  const handleClickName = async (id, caseId) => {
    await viewCase(id, caseId);
    navigate(`/cases/${id}/family-tree`);
    localStorage.setItem("caseId", caseId);
    localStorage.setItem("clientId", id);
  };
  const handleClickBookmark = (e, item) => {
    e.stopPropagation();
    handleUpdateList([{ ...item, isMarked: !item.isMarked }]);
  };
  const handleUpdateList = async (payload) => {
    const result = await updateCaseList(payload, uID);
    if (result?.success) {
      handleRefresh();
    }
  };
  const handleCloseDropdown = () => {
    setOpenConsultantFilter(false);
  };
  const handleDeleteList = async () => {
    const delList = list.filter((item) => item?.isChecked);
    setDeletedItems([...delList]);
    if (delList?.length) {
      const result = await updateCaseList(
        delList.map((item) => ({
          ...item,
          isMarked: false,
          isUpdated: false,
          isDeleted: true,
        })),
        uID
      );
      if (result?.success) {
        setTimerCheck(true);
        setTimer(5000);
        handleRefresh();
        handleClose();
      }
    }
  };
  const handleRestore = async () => {
    if (deletedItems?.length) {
      setBeingRestored(true);
      const result = await updateCaseList(
        deletedItems.map((item) => ({
          ...item,
          isMarked: false,
          isUpdated: false,
          isDeleted: false,
        })),
        uID
      );
      if (result?.success) {
        setBeingRestored(false);
        setTimerCheck(false);
        handleRefresh();
      }
    }
  };
  const handleClose = () => {
    setDeleteModal(false);
  };
  return (
    <>
      <div className="cases">
        <div className="input-wrapper">
          <input
            placeholder={t(getKeyFromText("Name, Surname, date of birth"))}
            className="custom-input"
            value={search}
            onChange={(e) => {
              handleSearch(e.target.value);
            }}
          />
          <SearchIcon
            className="search-icon"
            onClick={() => {
              handleRefresh();
              handleFilterStateActive();
            }}
          />
        </div>
        <div style={{ position: "relative" }}>
          <button
            type="button"
            className={selectedConsultant ? "stroke filter-btn" : "filter-btn"}
            disabled={searchFilterState}
            onClick={() => {
              setOpenConsultantFilter((pre) => !pre);
            }}
          >
            Filter
          </button>
          {openConsultantFilter && (
            <CasesDropdownMenu
              handleSubmit={(value) => {
                handleSetConsultantFilter(value);
                handleCloseDropdown();
                handleRefresh();
              }}
              handleClose={handleCloseDropdown}
              list={consultantsList}
              selectedValue={selectedConsultant}
            />
          )}
        </div>
        <h5
          onClick={() => {
            handleSearch("");
            handleRefresh();
            handleEntireCasesText();
            handleSetConsultantFilter();
          }}
          style={{
            pointerEvents: entireCasesText ? "all" : "none",
            cursor: "pointer",
          }}
          className="selected-consultants-names"
        >
          {entireCasesText && Array.isArray(selectedConsultantName)
            ? selectedConsultantName.map((el) => {
                return <span style={{ padding: "0 5px" }}>{el}</span>;
              })
            : ""}
        </h5>
      </div>
      <div
        className="cases-table"
        style={{
          minHeight: "500px",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: loading && "center",
        }}
      >
        {loading ? (
          <Circles color="#dfc8db" height={80} width={80} />
        ) : (
          <TableContainer component={Paper}>
            <Tooltip
              title={
                <Box textAlign="center" padding="8px">
                  Move to <br /> trash
                </Box>
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    borderRadius: "0",
                    bgcolor: "#a5a5a5",
                  },
                },
              }}
              leaveDelay={500}
            >
              <div
                style={{
                  backgroundColor: list.every((item) => !item.isChecked)
                    ? "#fff"
                    : "#dfc8db",
                  width: "30px",
                  margin: "10px",
                  borderRadius: "5px",
                  padding: "3px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DeleteIcon
                  style={{
                    opacity: list.every((item) => !item.isChecked)
                      ? "0.5"
                      : "1",
                    cursor: list.every((item) => !item.isChecked)
                      ? "default"
                      : "pointer",
                    pointerEvents: list.every((item) => !item.isChecked)
                      ? "none"
                      : "all",
                  }}
                  fill="#262b3e"
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                />
              </div>
            </Tooltip>

            <Table
              sx={{ minWidth: 650, maxHeight: "300px", overflow: "auto" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell />
                  <TableCell>{t(getKeyFromText("Name"))}</TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Date Of Birth"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Email"))}
                  </TableCell>
                  <TableCell align="left" />
                  <TableCell align="left">
                    {t(getKeyFromText("Updated date"))}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => {
                  return (
                    <TableRow
                      key={item.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        cursor: item.advisorId == uID ? "pointer" : "default",
                        ...(item.isChecked && {
                          backgroundColor: "color.magentaLight2",
                        }),
                      }}
                      onClick={(e) => {
                        if (item.advisorId == uID) {
                          e.stopPropagation() ||
                            handleClickName(item.clientId, item.caseId);
                        }
                      }}
                    >
                      <TableCell component="th" scope="row">
                        <div
                          style={{
                            marginTop: "-8px",
                            display: "flex",
                            alignItems: "left",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            id={item.caseId}
                            checked={item.isChecked}
                            onChange={handleChangeCheck}
                            theme={item.isChecked ? "checked" : "secondary"}
                          />
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        <BookmarkIcon
                          style={{
                            width: "20px",
                            display: "flex",
                            alignItems: "center",
                            fill: item.isMarked ? "#FFD76C" : "none",
                            cursor: "pointer",
                          }}
                          color={item.isMarked ? "#FFD76C" : "#A3A3A3"}
                          onClick={(e) => {
                            handleClickBookmark(e, item);
                          }}
                        />
                      </TableCell>
                      <TableCell sx={{ cursor: "pointer" }} align="left">
                        {item?.clientName || ""}
                      </TableCell>
                      <TableCell align="left">
                        <FormattedDate
                          date={item.clientDOB}
                          language={i18n.language}
                        />
                        {/* {item?.clientDateOfBirth || ""} */}
                      </TableCell>
                      <TableCell align="left" className="cases-email">
                        {item?.clientEmail || ""}
                      </TableCell>
                      <TableCell align="left">
                        {new Date(item.updatedDateByClient).getTime() >
                        new Date(item?.lastViewed).getTime() ? (
                          <div className="icon-avatar">
                            <BellIcon
                              fill="#FF996C"
                              style={{ width: "12px" }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {/* {item.updatedDateByClient?.slice(0, 10)} */}
                        <FormattedDate
                          date={item.updatedDateByClient}
                          language={i18n.language}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
      {(timerCheck || beingRestored) && (
        <RestoreCaseBox
          handleRestore={handleRestore}
          beingRestored={beingRestored}
        />
      )}

      {deleteModal && (
        <Modal
          keepMounted
          open={true}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Container maxWidth="xs">
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxWidth: 400,
                bgcolor: "background.paper",
                borderRadius: "15px",
                boxShadow: 24,
                p: 4,
                textAlign: "center",
                padding: "20px 20px",
                minWidth: 300,
              }}
            >
              <Typography sx={{ textAlign: "right", cursor: "pointer" }}>
                <CloseIcon onClick={handleClose} />
              </Typography>
              <Typography>
                <DeleteIcon
                  style={{
                    width: "35px",
                    margin: "10px",
                  }}
                />
              </Typography>
              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
              >
                {t("are-you-sure-you-want-to-delete-this-case")}
              </Typography>

              <Typography sx={{ mt: 3 }}>
                <SecondaryButton
                  title={t("yes")}
                  textTransform="initial"
                  width={false}
                  padding="0.25rem 3rem"
                  border="2px solid #C498BB40"
                  borderRadius={2}
                  fontSize="0.85rem"
                  fontWeight="500"
                  marginTop="4px"
                  click={handleDeleteList}
                />
              </Typography>
            </Box>
          </Container>
        </Modal>
      )}
    </>
  );
};

export default Cases;
